var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.dragging ? `${_vm.className} ${_vm.activeClass}` : `${_vm.className} ${_vm.inactiveClass}`,attrs:{"id":_vm.$el.id},on:{"dragover":function($event){{_vm.onDragOver}},"dragleave":function($event){{_vm.onDragLeave}},"drop":function($event){{_vm.onDrop}}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }